import { render, staticRenderFns } from "./CarbonCostByScopeDetail.vue?vue&type=template&id=4469ac72&scoped=true"
import script from "./CarbonCostByScopeDetail.vue?vue&type=script&lang=js"
export * from "./CarbonCostByScopeDetail.vue?vue&type=script&lang=js"
import style0 from "./CarbonCostByScopeDetail.vue?vue&type=style&index=0&id=4469ac72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4469ac72",
  null
  
)

export default component.exports